module.exports = __webpack_public_path__ + "img/VL_16_02.1298c428.png";